import * as Yup from 'yup';

import dayjs from 'dayjs';

export const shiftSchema = Yup.object().shape({
    start_time: Yup.mixed().required('Start Time is required'),
    end_time: Yup.mixed()
        .required('End Time is required')
        .test('not-same-time', 'Start and End time cannot be the same', function (value) {
            const { start_time } = this.parent;
            if (!start_time || !value) return true;
            return !dayjs(start_time).isSame(dayjs(value));
        })
        .test('is-minimal-duration', 'Shift duration must be at least 2 hours', function (value) {
            const { start_time } = this.parent;
            if (!start_time || !value) return true;

            const start = dayjs(start_time);
            let end = dayjs(value);

            // Handle overnight: if end is before start, assume next day
            if (end.isBefore(start)) {
                end = end.add(1, 'day');
            }

            const diffInMinutes = end.diff(start, 'minute');
            return diffInMinutes >= 120;
        }),
    break_hours: Yup.number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .nullable()
        .required('Break Hours is required')
        .min(0, 'Break hours cannot be negative')
        .max(4, 'Break hours cannot exceed 4'),
    shift_type: Yup.string()
        .required('Shift Type is required')
        .matches(/^(?![0-9]+$)[a-zA-Z0-9 ]+$/, 'Shift Type must be letters and numbers only'),
    color: Yup.string().required('Please select a color')
});
